import { FETCH_ACCOUNT_LETTERS_HISTORY } from "./types";
import { sortSearchPaginateActions } from "@/store/common/actions";
import * as contactApi from "@/api-client/contacts";

export default {
  async fetchAccountLettersHistory({ commit }, { page = 1, sorting, searchString, page_size } = {}) {
    commit({
      type: FETCH_ACCOUNT_LETTERS_HISTORY.request
    });

    try {
      const history = await contactApi.fetchAccountLettersHistory(page, sorting, searchString, page_size);

      commit({
        type: FETCH_ACCOUNT_LETTERS_HISTORY.success,
        payload: history
      });
    } catch (e) {
      commit({
        type: FETCH_ACCOUNT_LETTERS_HISTORY.error,
        error: e.message
      });
    }
  },

  ...sortSearchPaginateActions
};
